import logo from "../assets/logo.png";

export const appColors = {
  primary1: "#124170",
  primary2: "#26667F",
  light2: "#67C090",
  danger: "#E4004B",
  text: "#44444E",
};

export const appLogo = logo;
